<style scoped lang="less">
.table-expand {
    padding-left: 20px;
    padding-right: 20px;
    .item {
        width: 100%;
        margin: 7px 0;
        display: flex;
        .label {
            width: 100px;
            margin-right: 20px;
            text-align: justify;
            text-align-last: justify;
            color: #909399;
            font-size: 14px;
        }
        .value {
            flex: 1;
            font-size: 14px;
            color: #303133;
            display: flex;
            flex-direction: column;
            .stack {
                width: 100%;
                word-break: break-all;
                line-height: 22px;
            }
        }
    }
}
.input-group {
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-input size="mini" class="input-group" style="width: 200px" clearable @keyup.native.enter="refetchData"
                v-model="userPhone">
                <template slot="prepend">手机号</template>
            </el-input>
            <el-input size="mini" class="input-group" style="width: 200px" clearable @keyup.native.enter="refetchData"
                v-model="userName">
                <template slot="prepend">受益人</template>
            </el-input>
            <el-input size="mini" class="input-group" style="width: 300px" clearable @keyup.native.enter="refetchData"
                v-model="goodTitle">
                <template slot="prepend">商品名称</template>
            </el-input>
        </div>
        <div>
            <span>成立日：<el-date-picker style="width: 250px" @change="refetchData" v-model="startDate" type="daterange"
                    range-separator="至" start-placeholder="成立开始" end-placeholder="成立结束"
                    size="mini"></el-date-picker></span>
            <span class="margin-l">到期日：<el-date-picker style="width: 250px" @change="refetchData" v-model="endDate"
                    type="daterange" range-separator="至" start-placeholder="到期开始" end-placeholder="到期结束"
                    size="mini"></el-date-picker></span>
        </div>
        <div class="block-mini-top">
            <span>打款日：<el-date-picker style="width: 250px" @change="refetchData" v-model="paymentDate" type="daterange"
                    range-separator="至" start-placeholder="打款开始" end-placeholder="打款结束"
                    size="mini"></el-date-picker></span>
            <el-button class="margin-l" size="mini" type="primary" @click.stop="refetchData">搜索</el-button>
            <el-button class="margin-l" size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
            <el-button class="margin-l" size="mini" type="warning" @click.stop="exportXlsx()"
                :loading="exportLoading">导出Excel</el-button>
        </div>
        <div class="block-mini-top">
            <span>
                投资额合计：{{totalAmount/10000}}万
            </span>
        </div>

        <paged-table class="block-mini-top" :page-size="30" ref="table" @fetch-data="fetchData">
            <el-table @sort-change="handleSort" @filter-change="handleFilter" slot :data="data" border size="mini"
                :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="45"></el-table-column>
                <el-table-column type="expand" width="30">
                    <template slot-scope="props">
                        <div class="table-expand">
                            <div class="item">
                                <div class="label">理财顾问姓名</div>
                                <div class="value">
                                    {{ props.row.advisorName }}
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">理财顾问电话</div>
                                <div class="value">
                                    {{ props.row.advisorPhone }}
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">银行</div>
                                <div class="value">
                                    {{ props.row.bank }}-{{
                                        props.row.bankUsername
                                    }}-{{ props.row.bankCard }}
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">计息明细</div>
                                <div class="value">
                                    <div class="stack" v-for="item in calcRateDates(
                                            props.row.rateDates
                                        )">
                                        {{
                                            item.date
                                        }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                                            item.days
                                        }}天&nbsp;&nbsp;&nbsp;&nbsp;￥{{
                                            item.money
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="销售" prop="title" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.admin }}
                    </template>
                </el-table-column> -->
                <el-table-column :filters="admins" :filter-multiple="false" column-key="admin" label="销售" prop="admin"
                    align="center" width="90">
                </el-table-column>
                <el-table-column label="受益人" align="center" width="120">
                    <template slot-scope="scope" v-if="scope.row.user">
                        {{ scope.row.user.name }}
                    </template>
                </el-table-column>
                <el-table-column label="投资额(万元)" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row.amount">
                        {{ scope.row.amount / 10000 }}
                    </template>
                </el-table-column>
                <el-table-column label="产品名称" prop="title" align="center" width="300">
                    <template slot-scope="scope">
                        <div v-if="!scope.row.good && scope.row.title" style="text-decoration:line-through">
                            {{scope.row.title}}</div>
                        <div v-if="scope.row.good && scope.row.good.title">{{scope.row.good.title}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="产品期限(月)" align="center" width="60">
                    <template slot-scope="scope">
                        {{ scope.row.term }}
                    </template>
                </el-table-column>
                <el-table-column label="年化收益" align="center" width="70">
                    <template slot-scope="scope">
                        {{ scope.row.rate }}%
                    </template>
                </el-table-column>
                <el-table-column :filters="[
                        { text: '季度付息', value: '季度付息' },
                        { text: '半年付息', value: '半年付息' },
                        { text: '按年付息', value: '按年付息' },
                    ]" :filter-multiple="false" column-key="payMethod" label="付息方式" prop="payMethod" align="center"
                    width="90">
                </el-table-column>
                <el-table-column label="打款日" align="center" width="110">
                    <template slot-scope="scope" v-if="scope.row.paymentDate">
                        {{ scope.row.paymentDate | fmt-date }}
                    </template>
                </el-table-column>
                <el-table-column label="成立日" align="center" width="110" sortable="custom">
                    <template slot-scope="scope" v-if="scope.row.startDate">
                        {{ scope.row.startDate | fmt-date }}
                    </template>
                </el-table-column>
                <el-table-column label="最近付息日" align="center" width="110" sortable="custom">
                    <template slot-scope="scope">
                        {{ calcPayDate(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="到期日" align="center" width="110" sortable="custom">
                    <template slot-scope="scope" v-if="scope.row.endDate">
                        {{ scope.row.endDate | fmt-date }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" class="super-mini-button"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" class="super-mini-button"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                        <el-button type="success" size="mini" class="super-mini-button"
                            @click.stop="copy(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>
        <dialog-edit-order ref="edit" @fetch-data="fetchData"></dialog-edit-order>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";

import DialogEditOrder from "../components/dialog/dialogEditOrder.vue";
import { actionConfirm, msgError, msgSuccess } from "../util/toast";
import { loginState } from "../util/login.js";
import { exportExcel } from "../util/exportExcel";

export default {
    components: {
        DialogEditOrder,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            admin: "",
            admins: [],
            userName: "",
            userPhone: "",
            title: "",
            goodTitle: "",
            payMethod: "",
            sortMethod: "",
            loading: false,
            exportLoading: false,
            startDate: [],
            endDate: [],
            paymentDate: [],
            isFilter: false,
            totalAmount: 0,
        };
    },
    created() {
        this.fetchAdmins();
    },
    mounted() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        async exportXlsx() {
            await actionConfirm();
            this.exportLoading = true;
            let res = await HttpClient.post(
                "/order/getAll",
                this.getCond(20000)
            );
            if (!res.result) msgError(res.msg);
            let list = res.result.map((it) => {
                return {
                    销售: it.admin ? it.admin : "",
                    受益人: it.user && it.user.name ? it.user.name : "",
                    "投资额(万元)": it.amount ? it.amount / 10000 : "",
                    产品名称: it.good && it.good.title ? it.good.title : "",
                    "产品期限(月)": it.term ? it.term : "",
                    年化收益: it.rate ? it.rate + "%" : "",
                    付息方式: it.payMethod ? it.payMethod : "",
                    打款日: it.paymentDate
                        ? dayjs(it.paymentDate).format("YYYY-MM-DD")
                        : "",
                    成立日: it.startDate
                        ? dayjs(it.startDate).format("YYYY-MM-DD")
                        : "",
                    最近付息日: this.calcPayDate(it),
                    到期日: it.endDate
                        ? dayjs(it.endDate).format("YYYY-MM-DD")
                        : "",
                };
            });
            exportExcel(
                list,
                dayjs().format("YYYY-MM-DD_HH:mm:ss") +
                    `_${res.count}` +
                    "_orders.xlsx"
            );
            this.exportLoading = false;
        },
        async fetchAdmins() {
            let res = await HttpClient.post("/admin/getAll");
            this.admins = res.map((it) => {
                return { text: it.description, value: it.description };
            });
        },
        handleFilter(column) {
            if (column.payMethod) {
                if (column.payMethod.length) {
                    this.payMethod = column.payMethod[0];
                } else {
                    this.payMethod = "";
                }
            }
            if (column.admin) {
                if (column.admin.length) {
                    this.admin = column.admin[0];
                } else {
                    this.admin = "";
                }
            }
            this.refetchData();
        },
        handleSort(data) {
            let label = data.column.label;
            let order = data.order;
            if (label == "成立日") {
                if (order == "descending") {
                    this.sortMethod = "成立日2→1";
                } else if (order == "ascending") {
                    this.sortMethod = "成立日1→2";
                } else {
                    this.sortMethod = "";
                }
            } else if (label == "到期日") {
                if (order == "descending") {
                    this.sortMethod = "到期日2→1";
                } else if (order == "ascending") {
                    this.sortMethod = "到期日1→2";
                } else {
                    this.sortMethod = "";
                }
            } else if (label == "最近付息日") {
                if (order == "descending" || order == "ascending") {
                    this.sortMethod = "最近付息日";
                } else {
                    this.sortMethod = "";
                }
            }
            this.refetchData();
        },
        calcPayDate(item) {
            if (dayjs(item.payDate).diff(dayjs(), "years") < 90) {
                return dayjs(item.payDate).format("YYYY-MM-DD");
            } else {
                return "已到期";
            }
        },
        calcRateDates(rateDates) {
            let rateArr = JSON.parse(rateDates);
            let arr = [];
            let days = 0;
            let money = 0;
            for (let i = 0; i < rateArr.length; i++) {
                const it = rateArr[i];
                arr.push({
                    ...it,
                    date: dayjs(it.date).format("YYYY-MM-DD"),
                });
                days += it.days;
                money += parseFloat(it.money);
            }
            arr.push({ date: "——合计：", days, money: money.toFixed(2) });
            return arr;
        },
        refetchData() {
            this.table.refetchData();
        },
        getCond(pageSize = this.table.pageSize) {
            let cond = {
                pageSize,
                pageNum: this.table.pageNum,
            };
            if (this.admin) {
                cond = { ...cond, admin: this.admin };
            }
            if (this.userName) {
                cond = { ...cond, userName: this.userName };
            }
            if (this.userPhone) {
                cond = { ...cond, userPhone: this.userPhone };
            }
            if (this.title) {
                cond = { ...cond, title: this.title };
            }
            if (this.goodTitle) {
                cond = { ...cond, goodTitle: this.goodTitle };
            }
            if (this.payMethod) {
                cond = { ...cond, payMethod: this.payMethod };
            }
            if (this.paymentDate && this.paymentDate.length) {
                let [start, end] = this.paymentDate;
                cond = {
                    ...cond,
                    paymentDate: {
                        $gte: dayjs(start).startOf("day"),
                        $lte: dayjs(end).endOf("day"),
                    },
                };
            }
            if (this.startDate && this.startDate.length) {
                let [start, end] = this.startDate;
                cond = {
                    ...cond,
                    startDate: {
                        $gte: dayjs(start).startOf("day"),
                        $lte: dayjs(end).endOf("day"),
                    },
                };
            }
            if (this.endDate && this.endDate.length) {
                let [start, end] = this.endDate;
                cond = {
                    ...cond,
                    endDate: {
                        $gte: dayjs(start).startOf("day"),
                        $lte: dayjs(end).endOf("day"),
                    },
                };
            }
            if (this.sortMethod) {
                cond = { ...cond, sortMethod: this.sortMethod };
            }
            return cond;
        },
        async fetchData() {
            this.loading = true;
            let res = await HttpClient.post("/order/getAll", this.getCond());
            this.loading = false;
            if (!res.result) msgError(res.msg);
            this.totalAmount = res.totalAmount ? res.totalAmount : 0;
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        copy(item) {
            let newItem = JSON.parse(JSON.stringify(item));
            delete newItem._id;
            this.edit.addOrEdit(newItem);
        },
        async removeModel(item) {
            await actionConfirm();
            this.loading = true;
            let res = await HttpClient.post("/order/delete", { _id: item._id });
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
